import { ContentSection } from '../../PageContent/MainContent';
import HotelRating from '../HotelRating';

import type { HotelReviewSummary } from '@shared/types/hotel-content';
import type { Nullable } from '@shared/types/utils';

import STYLES from './ReviewsRatingSection.module.scss';

type Props = {
  reviewSummary: Nullable<HotelReviewSummary>;
};

const ReviewsRatingSection = ({ reviewSummary }: Props) => {
  if (!reviewSummary?.score) {
    return null;
  }

  return (
    <ContentSection className={STYLES.ReviewsRatingSection__withoutShallow}>
      <HotelRating showRatingTitle={false} reviewSummary={reviewSummary} />
    </ContentSection>
  );
};

export default ReviewsRatingSection;
